import React, { ReactNode } from 'react';

interface CvIconContainerProps {
    children: ReactNode;
}

function CvIconContainer({ children }: CvIconContainerProps): React.JSX.Element {
    return <div className="size-10">{children}</div>;
}

export default CvIconContainer;
